import FileSaver from 'file-saver';
import { populateExcelFile } from './excelTemplatePopulator';
import findExcelTemplate from './templates/ExcelTemplate';

export const makeFileName = (reportName, generatedOnDateTime) =>
  `${reportName}_${generatedOnDateTime.substring(0, 16)}.xlsx`;

export const saveFile = (filename, file) => {
  const buf = new ArrayBuffer(file.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i !== file.length; i += 1) {
    view[i] = file.charCodeAt(i) & 0xFF; // eslint-disable-line no-bitwise
  }

  FileSaver.saveAs(
    new window.Blob([buf], { type: 'application/octet-stream' }),
    filename,
  );
};

const downloadReportAsXlsx = (data, columns, reportMetaData, selectionCriteria, totalRow) => {
  const {
    reportCode,
    generatedOnDateTime,
    reportMode,
  } = reportMetaData;

  const excelTemplateFile = findExcelTemplate((!reportMode || reportMode.toLowerCase() ===
    'default')
    ? reportCode
    : `${reportCode}_${reportMode.toUpperCase()}`);

  const populatedExcelFile = populateExcelFile(excelTemplateFile, reportMetaData, data, columns, selectionCriteria, totalRow);

  saveFile(makeFileName(reportCode, generatedOnDateTime), populatedExcelFile);
};

export default downloadReportAsXlsx;
